export default __webpack_public_path__ + "static/media/FLY.0bfc809c.png";